<template>
  <v-container fluid>
    <v-dialog v-model="createCampaignDialog" width="500">
      <v-card class="border-radius-standard">
        <v-card-title class="headline" primary-title style="font-size: 28px">
          {{
            selected && selected.length && selected.length === 1
              ? "Rename Campaign"
              : "Create New Campaign"
          }}
          <v-spacer />
          <v-icon @click="createCampaignDialog = false">close</v-icon>
        </v-card-title>
        <v-card-text>
          <add-campaign
            ref="addCampaign"
            :put="
              selected && selected.length && selected.length === 1
                ? selected[0]
                : null
            "
            @loading="addButtonLoader = $event"
            @success="handleAddCampaign"
          >
            <label
              slot="before-name"
              class="black--text"
              style="font-size: 16px"
              >Campaign Name</label
            >
            <label
              slot="before-channel"
              class="black--text"
              style="font-size: 16px"
              >Message Type</label
            >
            <label slot="before-app" class="black--text" style="font-size: 16px"
              >Sender Number</label
            >
            <label
              slot="before-template"
              class="black--text"
              style="font-size: 16px"
              >Template Message</label
            >
          </add-campaign>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn outline @click="createCampaignDialog = false"> Cancel </v-btn>
          <v-btn
            :loading="addButtonLoader"
            color="primary"
            @click="addNewCampaign"
          >
            {{
              selected && selected.length && selected.length === 1
                ? "Rename"
                : "Create"
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteCampaignDialog" width="400">
      <v-card v-if="selected && selected.length" class="border-radius-standard">
        <v-card-title class="headline" primary-title>
          Delete {{ selected.map((campaign) => campaign.name).join(", ") }}
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete this Campaign?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="black" outline @click="deleteCampaignDialog = false">
            Cancel
          </v-btn>
          <v-btn
            :loading="addButtonLoader"
            color="error"
            @click="deleteCampaigns"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <h1>My Campaigns</h1>
      <v-spacer />
    </v-layout>
    <v-flex xs12> </v-flex>
    <v-flex xs12>
      <v-card class="card-curvey">
        <v-layout row wrap>
          <v-flex xs4>
            <v-text-field
              v-model="queries.q"
              placeholder="Search by Name, ID, State..."
              campaignend-icon="search"
              outline
            />
          </v-flex>
          <v-spacer />
          <v-btn
            :loading="!!(addButtonLoader && !selected.length)"
            color="blue-grey"
            class="nlp-nav-btn"
            small
            outline
            @click="openAddDialog(true)"
          >
            <v-icon>add</v-icon>
            New Campaign
          </v-btn>
        </v-layout>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="campaigns"
            item-key="_id"
            :pagination.sync="pagination"
            :total-items="serverItemsLength"
            no-data-text="No Campaigns Available"
            class="elevation-1 nlp-data-table"
            :loading="loading"
          >
            <template slot="items" slot-scope="props">
              <tr
                v-if="props.index === 0 && !props.item.name"
                class="text-center"
                style="width: 100%"
              >
                <td />
                <td />
                <td />
                <td class="text-center">No Campaigns Available</td>
                <td />
                <td />
              </tr>

              <tr v-if="props.item.name">
                <td>
                  <span
                    class="primary--text pointer-cursor"
                    @click="selectCampaign(props.item)"
                  >
                    {{ props.item._id }}
                  </span>
                </td>
                <td>
                  <span
                    class="primary--text pointer-cursor"
                    @click="selectCampaign(props.item)"
                  >
                    {{ props.item.name }}
                  </span>
                </td>
                <td>
                  {{ props.item.message.template_message_name }}
                </td>
                <td class="text-center">
                  {{ props.item.app.phone_number }}
                </td>
                <td class="text-center">{{ props.item.total_receivers }}</td>
                <td style="text-transform: capitalize">
                  <p
                    :class="[
                      'text-center',
                      { 'purple--text': props.item.status === 'DRAFT' },
                      { 'red--text': props.item.status === 'REJECTED' },
                      { 'green--text': props.item.status === 'SENT' },
                      { 'amber--text': props.item.status === 'SCHEDULED' },
                      { 'blue--text': props.item.status === 'QUEUED' },
                      { 'orange--text': props.item.status === 'SENDING' },
                      { 'red--text': props.item.status === 'CANCELED' },
                    ]"
                  >
                    {{
                      props.item.status ? props.item.status.toLowerCase() : ""
                    }}
                  </p>
                  <span
                    v-if="props.item.status === 'SCHEDULED'"
                    style="font-size: 12px; color: #666"
                    >{{
                      props.item.schedule
                        ? `${formatScheduleTime(props.item.schedule).date}:${
                            formatScheduleTime(props.item.schedule).time
                          } - ${props.item.schedule.timezone}`
                        : ""
                    }}</span
                  >
                </td>
                <td class="text-center">
                  {{
                    props.item.created_at
                      ? $moment(props.item.created_at).format("D/M/YYYY H:m A")
                      : "N/A"
                  }}
                </td>
                <td
                  style="
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    padding-right: 0 !important;
                  "
                >
                  <v-tooltip
                    bottom
                    v-if="
                      ['DRAFT', 'SCHEDULED', 'CANCELED'].indexOf(
                        props.item.status
                      ) !== -1
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        class="px-3 campaigns-small-actions-btn"
                        :to="`/campaigns/${props.item._id}/editor`"
                      >
                        <v-icon class="campain-small-action-icon">edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template
                      v-slot:activator="{ on }"
                      v-if="
                        ['DRAFT', 'SCHEDULED', 'CANCELED'].indexOf(
                          props.item.status
                        ) === -1
                      "
                    >
                      <v-btn
                        v-on="on"
                        class="px-3 campaigns-small-actions-btn"
                        :to="`/campaigns/${props.item._id}/overview`"
                      >
                        <v-icon class="campain-small-action-icon"
                          >remove_red_eye</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>View</span>
                  </v-tooltip>
                  <!-- <v-tooltip
                    bottom
                    v-if="['CANCELED'].indexOf(props.item.status) === -1"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        class="px-3 campaigns-small-actions-btn"
                        @click="initCopyCampaign(props.item)"
                      >
                        <v-icon class="campain-small-action-icon"
                          >content_copy</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Copy</span>
                  </v-tooltip> -->
                  <v-tooltip
                    bottom
                    v-if="
                      ['SENT', 'SCHEDULED', 'SENDING'].indexOf(
                        props.item.status
                      ) === -1
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        class="px-3 campaigns-small-actions-btn"
                        @click="initDeleteCampaign(props.item)"
                      >
                        <span
                          class="botter-trash-icon campain-small-action-bot-icon"
                          style="color: #7f7f7f"
                        />
                      </v-btn>
                    </template>
                    <span>Delete</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import AddCampaign from "@/components/campaign-manager/campaigns-crud/AddCampaign.vue";
import * as _ from "lodash";
export default {
  name: "CampaignList",
  components: {
    AddCampaign,
  },
  data() {
    return {
      loading: false,
      pagination: { page: 1, rowsPerPage: 10 },
      internalPaginationUpdate: false,
      serverItemsLength: 0,
      queries: { q: "" },
      createCampaignDialog: false,
      deleteCampaignDialog: false,
      addButtonLoader: false,
      selected: [],
      headers: [
        {
          text: "ID",
          align: "left",
          sortable: false,
          value: "_id",
        },
        {
          text: "Campaign Name",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Template Message",
          value: "message.template_message_name",
          align: "center",
          sortable: false,
        },
        {
          text: "WhatsApp Number",
          value: "app",
          align: "center",
          sortable: false,
        },
        {
          text: "Number Of Recievers",
          value: "count",
          align: "center",
          sortable: false,
        },
        {
          text: "State",
          value: "status",
          align: "center",
          sortable: false,
        },
        {
          text: "Created At",
          value: "created_at",
          align: "center",
          sortable: false,
        },
        { text: "Actions", value: "actions", align: "right", sortable: false },
      ],
    };
  },
  computed: {
    campaigns() {
      return this.$store.state.campaigns.campaigns;
    },
  },
  watch: {
    selected: {
      deep: true,
      handler(val) {
        if (val && val.length && val.length > 1) {
          this.selected = [val[val.length - 1]];
        }
      },
    },
    pagination: {
      deep: true,
      handler() {
        if (this.internalPaginationUpdate) return;
        this.fetchCampaigns();
      },
    },
    "queries.q": {
      handler: _.debounce(function () {
        this.pagination.page = 1;
        this.fetchCampaigns();
      }, 300),
    },
  },
  async mounted() {
    // get campaigns
    await this.fetchCampaigns();

    if (this.$route.query.cb && this.$route.query.cb === "add") {
      this.openAddDialog(true);
    }
  },
  methods: {
    async fetchCampaigns() {
      this.loading = true;
      const response = await this.$store.dispatch("campaigns/get", {
        page: this.pagination.page,
        per_page: this.pagination.rowsPerPage,
        q: this.queries.q,
      });
      const total = response.count;
      this.serverItemsLength = total;

      this.internalPaginationUpdate = true;
      Object.assign(this.pagination, {
        page: response.page,
        rowsPerPage: response.per_page || this.pagination.rowsPerPage,
        totalItems: total,
      });
      this.$nextTick(() => (this.internalPaginationUpdate = false));

      this.loading = false;
    },
    handleTableChange() {
      console.log(`options ${this.pagination}`);
      this.fetchCampaigns();
    },
    openAddDialog(reset = true) {
      if (reset) this.selected = [];
      this.createCampaignDialog = true;
    },
    addNewCampaign() {
      if (this.$refs.addCampaign) this.$refs.addCampaign.submit();
    },
    initEditCampaign(campaign) {
      this.selected = [campaign];
      this.openAddDialog(false);
    },
    async initCopyCampaign(item) {
      await this.$http_session_manager.post(`/campaigns/${item._id}/clone`, {
        name: `${item.name} - Copy`,
      });

      this.$store.dispatch("setSnackbar", {
        text: `Cloned Successfully`,
        color: "success",
      });
      await this.getCampaigns();
    },
    handleAddCampaign(e) {
      this.createCampaignDialog = false;
      this.$router.push(`/campaigns/${e._id}/editor`);
    },
    selectCampaign(campaign) {
      this.$store.dispatch("campaigns/select", campaign);

      if (campaign.status !== "DRAFT" && campaign.status !== "SCHEDULED") {
        this.$router.push(`/campaigns/${campaign._id}/overview`);
      } else {
        this.$router.push(`/campaigns/${campaign._id}/editor`);
      }
    },
    initDeleteCampaign(campaign) {
      this.selected = [campaign];
      this.deleteCampaignDialog = true;
    },
    async deleteCampaigns() {
      this.$store.dispatch("setLoader", true);
      await this.$store.dispatch(
        "campaigns/delete/single",
        this.selected[0]._id
      );
      this.$store.dispatch("setSnackbar", {
        text: `Deleted Successfully`,
        color: "success",
      });
      this.selected = [];

      this.deleteTemplateMessageDialog = false;
    },
    formatScheduleTime(schedule) {
      const timezone = schedule.timezone;
      const dateObj = new Date(schedule.date);

      const date = new Intl.DateTimeFormat("en-CA", {
        timeZone: timezone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(dateObj);

      const time = new Intl.DateTimeFormat("en-GB", {
        timeZone: timezone,
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }).format(dateObj);

      return { date, time };
    },
  },
};
</script>

<style lang="scss" src="@/assets/sass/commponents/nlp.scss" />
<style lang="scss">
.campaigns-small-actions-btn {
  height: 24px;
  width: 24px;
  max-width: 24px;
  min-width: 24px;
  border-radius: 3px !important;
  margin-left: 2px;
}
.campain-small-action-icon {
  font-size: 16px !important;
  margin-left: 4px;
  color: #7f7f7f !important;
}
.campain-small-action-bot-icon {
  font-size: 16px !important;
}
</style>
